<form [formGroup]="shiftsForm" *ngIf="shiftsForm">
	<h1 *ngIf="data.add" mat-dialog-title>Add Shifts</h1>
	<h1 *ngIf="data.addSingle" mat-dialog-title>Add Shift</h1>
	<h1 *ngIf="data.delete" mat-dialog-title>Delete Shifts</h1>
	<div mat-dialog-content>
		<div fxLayout="row" fxLayoutGap="20px" class="pt-2">
			<mat-form-field>
				<input
					matInput
					required
					[matDatepicker]="startDatePicker"
					formControlName="startDate"
					autocomplete="off"
					(click)="startDatePicker.open()"
					placeholder="Start Date"
				/>
				<mat-error> Start Date is <strong>required</strong> </mat-error>
				<mat-datepicker-toggle
					matSuffix
					[for]="startDatePicker"
				></mat-datepicker-toggle>
				<mat-datepicker #startDatePicker></mat-datepicker>
			</mat-form-field>
			<mat-form-field *ngIf="data.add || data.delete">
				<input
					matInput
					required
					[matDatepicker]="endDatePicker"
					formControlName="endDate"
					autocomplete="off"
					(click)="endDatePicker.open()"
					placeholder="End Date"
				/>
				<mat-error> End Date is <strong>required</strong> </mat-error>
				<mat-datepicker-toggle
					matSuffix
					[for]="endDatePicker"
				></mat-datepicker-toggle>
				<mat-datepicker #endDatePicker></mat-datepicker>
			</mat-form-field>
		</div>

		<div *ngIf="data.add">
			<mat-button-toggle-group multiple fxLayoutAlign="space-between">
				<mat-button-toggle id="sunday" (change)="isDaySelected($event)">
					Sun
				</mat-button-toggle>
				<mat-button-toggle id="monday" (change)="isDaySelected($event)">
					Mon
				</mat-button-toggle>
				<mat-button-toggle
					id="tuesday"
					(change)="isDaySelected($event)"
				>
					Tue
				</mat-button-toggle>
				<mat-button-toggle
					id="wednesday"
					(change)="isDaySelected($event)"
				>
					Wed
				</mat-button-toggle>
				<mat-button-toggle
					id="thursday"
					(change)="isDaySelected($event)"
				>
					Thr
				</mat-button-toggle>
				<mat-button-toggle id="friday" (change)="isDaySelected($event)">
					Fri
				</mat-button-toggle>
				<mat-button-toggle
					id="saturday"
					(change)="isDaySelected($event)"
				>
					Sat
				</mat-button-toggle>
			</mat-button-toggle-group>

			<mat-error
				class="pl-2"
				*ngIf="showToggleButtonError()"
				[@animateError]
			>
				<small>Please <strong>select</strong> days to add shifts</small>
			</mat-error>
		</div>

		<div
			*ngIf="data.add || data.addSingle"
			gdColumns="repeat(auto-fill, minmax(180px, 1fr))"
			gdGap="10px"
		>
			<mat-form-field>
				<input
					matInput
					[textMask]="{ mask: timeMask }"
					formControlName="startTime"
					placeholder="Start Time"
				/>
				<mat-hint>24 hr time. e.g: 07:00 / 19:00 </mat-hint>
				<mat-error>Invalid format! eg: 07:00 / 19:00</mat-error>
			</mat-form-field>
			<rpshared-service-type
				*ngIf="data.showServiceType"
				formControlName="serviceType"
			></rpshared-service-type>
			<mat-form-field *ngIf="!data.addSingle">
				<input
					required
					matInput
					type="number"
					formControlName="countPerDay"
					placeholder="Number of Field Workers for Shift Time"
				/>
				<mat-error
					># of shifts per day is <strong>required</strong></mat-error
				>
			</mat-form-field>
		</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="end" class="pr-3">
		<mat-error *ngIf="deleteConflicts" [@animateError]>
			<small>Warning: Deleting assigned shifts!</small>
		</mat-error>
	</div>
	<div mat-dialog-actions fxLayoutAlign="end">
		<button mat-button type="button" color="primary" (click)="cancel()">
			Cancel
		</button>
		<button
			*ngIf="data.add"
			mat-button
			color="primary"
			(click)="addShifts()"
			[disabled]="shiftsForm.invalid"
		>
			Add
		</button>
		<button
			*ngIf="data.addSingle"
			mat-button
			color="primary"
			(click)="addShift()"
			[disabled]="shiftsForm.invalid"
		>
			Add
		</button>
		<button
			*ngIf="data.delete && !deleteConflicts"
			mat-button
			color="warn"
			(click)="deleteShifts()"
			[disabled]="shiftsForm.invalid"
		>
			Delete
		</button>
		<button
			*ngIf="data.delete && deleteConflicts"
			mat-button
			color="warn"
			(click)="deleteShiftsAnyway()"
			[disabled]="shiftsForm.invalid"
		>
			Delete Anyway
		</button>
	</div>
</form>
